(function () {
    'use strict';

    angular
        .module('app.sso')
        .run(appRun);

    appRun.$inject = ['routerHelper'];
    /* @ngInject */
    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'sso.requestAccess',
                config: {
                    url: '/request-access',
                    templateUrl: 'app/sso/requestAccess/sso.requestAccess.html',
                    controller: 'RequestAccessController',
                    controllerAs: 'vm',
                    title: 'Request Access',
                    ncyBreadcrumb: {
                        label: 'Request Access'
                    },
                    settings: {
                        isVisible: false,
                        nav: 1,
                        content: ''
                    }
                }
            }
        ];
    }
})();
